import styled from "styled-components";
import GSAP from "gsap";
import Splitting from "splitting";
import { Button } from "antd";
import { useEffect, useRef } from "react";

const PASTEL_COLORS = [
  "ffadad",
  "ffd6a5",
  "FFF5B5",
  "caffbf",
  "9bf6ff",
  "a0c4ff",
  "bdb2ff",
  "ffc6ff",
];

export const Intro = () => {
  const timeline = useRef();

  const splitChars = () => {
    Splitting({
      target: "[data-splitting]",
      by: "chars",
      key: null,
    });
  };

  const onSkip = () => {
    timeline.current?.clear();
    onIntroFinish();
  };

  const onIntroFinish = () => {
    GSAP.set("#js-intro-wrapper", {
      display: "none",
    });

    GSAP.set("#js-main-app-wrapper", {
      height: "auto",
      overflow: "auto",
    });
  };

  useEffect(() => {
    splitChars();

    timeline.current = GSAP.timeline();

    GSAP.set("#js-main-app-wrapper", {
      height: "100vh",
      overflow: "hidden",
    });

    const headerChars = document.querySelectorAll("#js-header-wrapper .char");

    headerChars.forEach((char, i) => {
      GSAP.set(char, {
        color: `#${PASTEL_COLORS[i % PASTEL_COLORS.length]}`,
      });
    });

    timeline.current.from(
      headerChars,
      {
        opacity: 0,
        stagger: () => Math.random() * 3,
        delay: () => Math.random() * 2,
        duration: 3,
      },
      "0"
    );

    timeline.current.from(
      "#js-year-wrapper .char",
      {
        opacity: 0,
        stagger: 0.3,
        duration: 2,
      },
      "-=1"
    );

    timeline.current.to("#js-intro-wrapper", {
      opacity: 0,
      onComplete: onIntroFinish,
    });

    return () => {
      timeline.current.kill();
    };
  }, []);

  return (
    <Wrapper id="js-intro-wrapper">
      <div>
        <HeaderWrapper>
          <YearWrapper data-splitting id="js-year-wrapper">
            2022
          </YearWrapper>

          <Header data-splitting id="js-header-wrapper">
            Future <br /> Talent <br /> Show
          </Header>
        </HeaderWrapper>
      </div>
      <SkipButton type="primary" ghost onClick={onSkip} size="small">
        skip
      </SkipButton>
    </Wrapper>
  );
};

const COLORS = {
  background: "#f9f9ed",
  year: "#758173",
};

const SkipButton = styled(Button)`
  position: fixed;
  right: 32px;
  top: 32px;
`;

const HeaderWrapper = styled.div`
  text-align: center;
`;

const YearWrapper = styled.div`
  position: absolute;
  opacity: 0.5;
  width: 100vw;
  font-size: 300px;
  line-height: 100%;
  letter-spacing: 8px;
  color: ${COLORS.year};
  text-transform: uppercase;

  .char:nth-child(1) {
    position: fixed;
    top: -40px;
    left: 0;
  }

  .char:nth-child(2) {
    position: fixed;
    top: -40px;
    right: 0;
  }

  .char:nth-child(3) {
    position: fixed;
    bottom: 0;
    left: 0;
  }

  .char:nth-child(4) {
    position: fixed;
    bottom: 0;
    right: 0;
  }
`;

const Header = styled.div`
  font-weight: bold;
  font-size: 64px;
  line-height: 72px;
  letter-spacing: 8px;
  text-transform: uppercase;

  .char {
    position: relative;
  }
`;

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  background-color: ${COLORS.background};
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;
